<template>
  <div v-loading="loading" :key="chartKey" style="margin-bottom: -25px;">
    <apexchart type="bar" :options="options" :height="300" :series="series"/>
  </div>
</template>
<script>
export default {
  data() {
    return {
      options: {
        chart: {
          id: 'outstandings-chart',
        },
        stroke: {
          show: true,
          width: 3,
          colors: ['transparent']
        },
        dataLabels: {
          enabled: false
        },
        tooltip: {
          y: {
            formatter: (value, { series, seriesIndex, dataPointIndex, w }) => {
              return this.$options.filters.currency(value);
            }
          }
        },
        yaxis: {
          labels: {
            formatter: val => {
              return (parseFloat(val)
                .toFixed(2))
                .replace(/\D00$/, '') + ' Ft';
            }
          }
        }
      },
      series: [{
        name: 'Nettó',
        data: []
      }],
      chartKey: 0
    };
  },

  computed: {
    countyData() {
      return this.$store.getters['outstanding/outstandingsByCountries'];
    },

    loading() {
      return this.$store.getters['outstanding/countyLoading'];
    }
  },

  watch: {
    countyData(newVal) {
      this.setChartData(newVal);
    }
  },

  async mounted() {
    await this.$store.dispatch('outstanding/fetchByCounties');
  },

  methods: {
    setChartData(data) {
      this.series[0].data = [];
      data.forEach(county => {
        this.series[0].data.push(
          {
            x: county.name,
            y: county.net_sum || 0
          }
        );
      });
      this.chartKey++;
    }
  }
};
</script>
